export const FieldDataSkeleton = () => {
  return (
    <div data-testid="field-data-skeleton" className="flex animate-pulse space-x-4">
      <div className={`inline-flex max-w-full items-center space-x-2 p-1 text-sm font-medium`}>
        <div className="h-4 w-4 rounded-sm bg-gray-300" />
        <div className="h-4 w-4 rounded-sm bg-gray-300" />
      </div>
    </div>
  );
};
